import classes from "./veryNewProposalDesign.module.scss";
import ReactStars from 'react-stars';
import { BackSlideSvg, BedSvg, ButtonTickSvg, CartButtonSelectedSvg, CartButtonSvg, CircleTickSvg, DangerCircleSvg, DurationSvg, FeetSvg, ForSlideSvg, MapSvg, PersonSvg } from '../../constants/resources';
import { ItineraryAccommodation, ItineraryActivity, ItineraryRestaurant, SortedItem } from "../../atom/Types";
import { Tooltip } from 'react-tooltip'
import { checkSpacing } from "../../atom/utilities/function";

interface props {
    handleSuggested: (node: ItineraryRestaurant | ItineraryActivity | ItineraryAccommodation, index: number) => void
    handleAcco?: (node: ItineraryAccommodation, index: number) => void
    end: number
    singleNode: SortedItem
    setCurrentIndices: React.Dispatch<any>
    currentIndices: any
    ind: number
    scrollIndex: number
    setSuggesionData: React.Dispatch<React.SetStateAction<ItineraryActivity | ItineraryRestaurant | undefined>>
    setSuggestedModal: React.Dispatch<React.SetStateAction<boolean>>
    index: number
    handleReserved?: (node: ItineraryAccommodation, e: any) => void
}


const SingleSliderCard: React.FC<props> = ({ handleReserved, handleSuggested, index, end, singleNode, setCurrentIndices, currentIndices, ind, scrollIndex, setSuggesionData, setSuggestedModal, handleAcco }) => {

    function isAct(item: SortedItem): item is ItineraryActivity {
        return item.type === 'activity'
    }
    function isRes(item: SortedItem): item is ItineraryRestaurant {
        return item.type === 'Restaurant'
    }
    function isAcc(item: SortedItem): item is ItineraryAccommodation {
        return item.type === 'accommodation'
    }
    console.log(ind, 'looperrr');

    const calculateDays = (sD: string, eD: string) => {

        const startDate = new Date(sD).getTime()
        const endDate = new Date(eD).getTime()


        if (!isNaN(startDate) && !isNaN(endDate)) {
            const timeDifference = endDate - startDate;
            const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            return `${daysDifference} ${daysDifference === 1 ? `Night` : `Nights`}`
        } else {
            return null
        }

    }

    const handleSlide = (node: string, type: string) => {
        setCurrentIndices((prevIndices: any) =>
            prevIndices.map((index: any, idx: number) => {
                console.log(index, 'cucumber', idx,);

                if (idx !== scrollIndex) return index;

                const increment = node === 'forwards' ? 1 : -1;

                return type === 'act'
                    ? { ...index, start: index.start + increment, end: index.end + increment }
                    : { ...index, accoStart: index.accoStart + increment, accoEnd: index.accoEnd + increment };
            })
        );
    };


    const convertDecimalTime = (decimalTime: number) => {
        const hours = Math.floor(decimalTime);

        const minutes = Math.round((decimalTime - hours) * 60);

        let result = '';
        if (hours > 0) {
            result += hours === 1 ? '1 hour' : `${hours} h`;
        }

        if (minutes > 0) {
            result += hours > 0 ? ' and ' : '';
            result += minutes === 1 ? '1 minute' : `${minutes} m`;
        }

        return result;
    }

    const handleDetails = (node: ItineraryActivity | ItineraryRestaurant) => {

        setSuggesionData(node)
        setSuggestedModal(true)

    }


    console.log(singleNode, 'singleNode');
    return (
        <>
            {singleNode.type === "Restaurant" && isRes(singleNode) ? <div key={singleNode?.id} className={classes.card} onClick={() => handleSuggested(singleNode, index)}>
                <img src={singleNode?.restaurant?.media[0]?.url} alt='res' height='182px' style={{ width: window.innerWidth > 768 ? '282px' : window.innerWidth > 600 ? '260px' : window.innerWidth - 50 }} />
                <div className={classes.subCard}>
                    <div className={classes.topHead}>
                        {singleNode?.restaurant?.stars !== "" ?
                            <ReactStars
                                count={5}
                                value={singleNode?.restaurant?.stars.length}
                                edit={false}
                                size={24}
                                color1={"#E0E6ED"}
                                color2={'#FFC700'}

                            /> : null}

                        {singleNode?.durationHours && <div style={{ display: 'flex', alignItems: 'center' }}><DurationSvg /><p>{convertDecimalTime(singleNode?.durationHours)}</p></div>}
                    </div>
                    <p className={classes.cardHead} onClick={(event) => { handleDetails(singleNode); event.stopPropagation() }}>{singleNode?.restaurant?.name}</p>
                    <p className={classes.description} onClick={(event) => { handleDetails(singleNode); event.stopPropagation() }}>{singleNode?.restaurant?.description}</p>
                    <div className={classes.topHead} style={{ justifyContent: 'flex-end' }}>
                        {/* <div onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent>) => { handleDetails(singleNode); event.stopPropagation() }} className={classes.bottom} style={{ fontWeight: 500, fontSize: '14px' }}>
                            Details
                            <RightArrowSvg />
                        </div> */}
                        <button className={singleNode.selected ? classes.bottomSelectButton : classes.bottomButton}> {singleNode.selected && <ButtonTickSvg />}{singleNode.selected ? 'Selected' : 'Select'}</button>


                    </div>
                </div>
            </div> : singleNode.type === "accommodation" && isAcc(singleNode) && handleAcco ? <div key={singleNode?.id} className={classes.card} style={{ position: 'relative' }} onClick={() => handleAcco(singleNode, index)}>
                <img src={singleNode?.accommodation?.media[0]?.url} alt='act' height='182px' style={{ width: window.innerWidth > 768 ? '282px' : window.innerWidth > 600 ? '260px' : window.innerWidth - 50 }} />
                <div style={{ position: 'absolute', left: '10px', top: '10px', display: 'flex', gap: '10px' }}>
                    <button className={classes.imgButtons}>{singleNode?.accommodation?.numberOfStars} Star</button>
                    {singleNode.accommodation.adultsOnly && <button className={classes.imgButtons}>Adults only</button>}
                </div>
                <div className={classes.subCard} style={{ width: '100%', alignItems: 'flex-start', gap: '10px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <p className={singleNode?.selected ? classes.cardHead : classes.preCardHead}>{singleNode?.roomDetails[0]?.roomDetail.name}</p>
                        <p className={classes.accDesc}><PersonSvg /> Sleeps {singleNode?.roomDetails[0]?.roomDetail.maxOccupancy}</p>
                        <p className={classes.accDesc}><BedSvg />{singleNode?.roomDetails[0]?.roomDetail.beds}</p>
                        <p className={classes.accDesc}><FeetSvg />{singleNode?.roomDetails[0]?.roomDetail.size}</p>
                    </div>
                    <div>
                        <p className={classes.hotelName}><MapSvg /> {singleNode.accommodation.name}</p>
                        <p className={classes.accDesc}> {singleNode.accommodation.locality} {singleNode.accommodation.country}</p>
                    </div>
                    <div>
                        <p className={classes.hotelName}>Guest Number</p>
                        <p className={classes.accDesc}> <PersonSvg /> {singleNode.persons.length} Persons</p>
                    </div>
                    <div>
                        <p className={classes.hotelName}>Nights</p>
                        <p className={classes.accDesc}> <BedSvg /> {calculateDays(singleNode.checkInDate, singleNode.checkOutDate)}</p>
                    </div>
                    <div>
                        <p className={classes.hotelName}>Comment</p>
                        <p className={classes.accDesc}>{checkSpacing(singleNode.comment) ? singleNode.comment : `no comment`}</p>
                    </div>

                    <div className={classes.cancellation} style={{ width: '100%', textAlign: 'center' }}>
                        {checkSpacing(singleNode.cancellationPolicy) ? singleNode.cancellationPolicy : `unavailable`}
                    </div>

                    {singleNode.bookingStatus !== 'InReserve' ? <div className={classes.topHead}>
                        <div className={classes.bottom} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                            <span className={classes.span} style={{ color: '#545D68', marginLeft: '0px' }}>Full Property Price</span>
                            <span className={singleNode.payNow !== null && singleNode.payNow > 0 ? classes.span1 : classes.poppins1}> ${singleNode?.publishedPrice}{singleNode.payNow !== null && singleNode.payNow > 0 && <span data-tooltip-id="my-tooltip" data-tooltip-content="You’ll have to pay the rest of a Full Property Price at a location!"> <DangerCircleSvg /></span>}</span>
                            <Tooltip id="my-tooltip"
                                className={classes.tooltip}
                            />
                        </div>
                        {singleNode.payNow !== null && singleNode.payNow > 0 && <div className={classes.bottom} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                            <span className={classes.span} style={{ color: '#545D68', marginLeft: '0px' }}>Pay Now</span>
                            ${singleNode.payNow}
                        </div>}
                        {singleNode.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}
                    </div> : <div className={classes.topHead}>
                        <div className={classes.bottom} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                            <span className={classes.span} style={{ color: '#545D68', marginLeft: '0px' }}>Full Property Price</span>
                            <span className={singleNode.payNow !== null && singleNode.payNow > 0 ? classes.span1 : classes.poppins1}> ${singleNode?.publishedPrice}{singleNode.payNow !== null && singleNode.payNow > 0 && <span data-tooltip-id="my-tooltip" data-tooltip-content="You’ll have to pay the rest of a Full Property Price at a location!"> <DangerCircleSvg /></span>}</span>
                            <Tooltip id="my-tooltip"
                                className={classes.tooltip}
                            />
                        </div>
                        {handleReserved && <button className={classes.bottomButton} onClick={(e: any) => handleReserved(singleNode, e)}>
                            Reserve Now
                        </button>}
                    </div>}
                </div>

            </div> : isAct(singleNode) &&
            <div className={classes.card} key={singleNode?.id} onClick={() => handleSuggested(singleNode, index)}>
                <img src={singleNode?.activity?.media[0]?.url} alt='act' height='182px' style={{ width: window.innerWidth > 768 ? '282px' : window.innerWidth > 600 ? '260px' : window.innerWidth - 100 }} />
                <div className={classes.subCard}>
                    <div className={classes.topHead}>
                        <ReactStars
                            count={5}
                            value={5}
                            edit={false}
                            size={24}
                            color1={"#E0E6ED"}
                            color2={'#FFC700'}
                        />
                        {singleNode?.durationHours && <div style={{ display: 'flex', alignItems: 'center' }}><DurationSvg /><p>{convertDecimalTime(singleNode?.durationHours)}</p></div>}
                    </div>
                    <p className={classes.cardHead} onClick={(event) => { handleDetails(singleNode); event.stopPropagation() }}>{singleNode?.activity?.name}</p>
                    {checkSpacing(singleNode.comment) ? <p className={classes.description} onClick={(event) => { handleDetails(singleNode); event.stopPropagation() }} dangerouslySetInnerHTML={{ __html: singleNode.comment }}></p> :
                        <p className={classes.description} onClick={(event) => { handleDetails(singleNode); event.stopPropagation() }}>{singleNode.activity.description}</p>}
                    {singleNode.bookingStatus === 'InCart' && checkSpacing(singleNode.cancellationPolicy) && <div className={classes.cancellation}>
                        {singleNode.cancellationPolicy}
                    </div>}
                    {singleNode.bookingStatus === 'InCart' ? <div className={classes.topHead}>
                        <div className={classes.bottom} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                            <span className={classes.span} style={{ color: '#545D68', marginLeft: '0px' }}>Full Tour Price</span>
                            <span className={singleNode.payNow !== null && singleNode.payNow > 0 ? classes.span1 : classes.poppins1}> ${singleNode?.publishedPrice}{singleNode.payNow !== null && singleNode.payNow > 0 && <span data-tooltip-id="my-tooltip" data-tooltip-content="You’ll have to pay the rest of a Full Tour Price at a location!"> <DangerCircleSvg /></span>}</span>
                            <Tooltip id="my-tooltip"
                                className={classes.tooltip}
                            />
                        </div>
                        {singleNode.payNow !== null && singleNode.payNow > 0 && <div className={classes.bottom} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                            <span className={classes.span} style={{ color: '#545D68', marginLeft: '0px' }}>Pay Now</span>
                            ${singleNode.payNow}
                        </div>}
                        {singleNode.selected ? <button className={classes.cartButtonSelected}><CartButtonSelectedSvg /><span><CircleTickSvg /></span></button> : <button className={classes.cartButton}><CartButtonSvg /></button>}
                        {/* <button className={singleNode.selected ? classes.bottomSelectButton : classes.bottomButton}> {singleNode.selected && <ButtonTickSvg />}{singleNode.bookingStatus === 'Proposal' && singleNode.selected ? 'Selected' : singleNode.bookingStatus === 'InCart' && singleNode.selected ? 'Added' : singleNode.bookingStatus === 'Proposal' ? 'Select' : 'Add to Cart'}</button> */}
                    </div> : <div className={classes.topHead} style={{ justifyContent: 'flex-end' }}>
                        <button className={singleNode.selected ? classes.bottomSelectButton : classes.bottomButton}> {singleNode.selected && <ButtonTickSvg />}{singleNode.selected ? 'Selected' : 'Select'}</button>

                    </div>}
                </div>
            </div>}
            {(singleNode.type === 'activity' || singleNode.type === 'Restaurant') && (ind === 0) && (end !== 1) ? <div style={{ marginTop: '20px' }}>
                <div style={{ display: 'flex', gap: '4px' }}>
                    <button disabled={currentIndices[scrollIndex].start === 0} onClick={() => handleSlide('backwards', 'act')} className={currentIndices[scrollIndex].start === 0 ? classes.disableCard : classes.slide}>
                        <BackSlideSvg />
                    </button>
                    <button className={currentIndices[scrollIndex].end === end - 1 ? classes.disableCard : classes.slide}
                        disabled={currentIndices[scrollIndex].end === end - 1}
                        onClick={() => handleSlide('forwards', 'act')}>
                        <ForSlideSvg />
                    </button>
                </div>
            </div> : null}
            {(singleNode.type === 'accommodation') && (ind === 0) && (end !== 1) ? <div style={{ marginTop: '20px' }}>
                <div style={{ display: 'flex', gap: '4px' }}>
                    <button disabled={currentIndices[scrollIndex].accoStart === 0} onClick={() => handleSlide('backwards', 'acco')} className={currentIndices[scrollIndex].accoStart === 0 ? classes.disableCard : classes.slide}>
                        <BackSlideSvg />
                    </button>
                    <button className={currentIndices[scrollIndex].accoEnd === end - 1 ? classes.disableCard : classes.slide}
                        disabled={currentIndices[scrollIndex].accoEnd === end - 1}
                        onClick={() => handleSlide('forwards', 'acco')}>
                        <ForSlideSvg />
                    </button>
                </div>
            </div> : null}

        </>
    )
}

export default SingleSliderCard